import * as yup from 'yup';
import docs from './attachments';
import {
  parentesco,
  cpfResponsavelLegal,
  nomeDoTutor,
  adiantamentoQuinzenal,
  acessoContraCheque,
  // acessoJornalForluz,
  consentimentoDescontoFolha,
  consentimentoDadosSensiveis,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const RCMVariavelPlanoBSchema = yup.object({
  ...parentesco,
  ...cpfResponsavelLegal,
  ...nomeDoTutor,
  ...adiantamentoQuinzenal,
  ...acessoContraCheque,
  // ...acessoJornalForluz,
  ...consentimentoDescontoFolha,
  ...consentimentoDadosSensiveis(),
  ...declaracaoVeracidade,
  ...consentimentoAcertoFinanceiro,
  ...docs.anexosComObito.rules,
  ...aceiteInss,
});

export const RCMVariavelPlanoBInitialValues = {
  parentesco: '',
  cpfResponsavelLegal: '',
  nomeDoTutor: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  consentimentoDadosSensiveis: false,
  declaracaoVeracidade: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  ...docs.anexosComObito.initialValues,
};

export const RCMVariavelPlanoBDocs = {
  ...docs.anexosComObito.docs,
};
